import {
    DocsVerificationAddressTypeEnum,
    DocsVerificationBiometricTypeEnum,
    DocsVerificationDocumentKybEnum,
    DocsVerificationDocumentTypeEnum,
    DocsVerificationPhotosKeysEnum,
    DocsVerificationTypeEnum,
} from '@models/enums';

export const VERIFICATION = {
    ATTEMPTS_CHANGE_STATUS: 3,
};

export const VERIFICATION_CONSTANTS_TRANSFORM_PHOTOS = {
    POI: [
        DocsVerificationTypeEnum.POI,
        DocsVerificationDocumentTypeEnum.PASSPORT,
        DocsVerificationDocumentTypeEnum.ID_CARD,
        DocsVerificationDocumentTypeEnum.RESIDENCE_PERMIT,
        DocsVerificationDocumentTypeEnum.VISA,
        DocsVerificationDocumentTypeEnum.DRIVER_LICENSE,
    ],
    LIVENESS: [
        DocsVerificationTypeEnum.LIVENESS,
        DocsVerificationBiometricTypeEnum.SELFIE,
        DocsVerificationBiometricTypeEnum.LIVENESS_PHOTO,
        DocsVerificationBiometricTypeEnum.LIVENESS_PHOTO_EXTRA,
    ],
    POA: [
        DocsVerificationTypeEnum.POA,
        DocsVerificationAddressTypeEnum.POA_UTILITY_BILL,
        DocsVerificationAddressTypeEnum.POA_BANK_STATEMENT,
        DocsVerificationAddressTypeEnum.POA_RESIDENCE_REGISTRATION,
    ],
    KYB: [
        DocsVerificationDocumentKybEnum.KYB_OWNERSHIP_DOCUMENT,
        DocsVerificationDocumentKybEnum.KYB_CERTIFICATE_OF_INCORPORATION,
    ],
    FRONT_DOCUMENT_TYPES: [
        DocsVerificationPhotosKeysEnum.RESIDENCE_PERMIT_FRONT,
        DocsVerificationPhotosKeysEnum.ID_CARD_FRONT,
        DocsVerificationPhotosKeysEnum.DRIVER_LICENSE_FRONT,
    ],
    BACK_DOCUMENT_TYPES: [
        DocsVerificationPhotosKeysEnum.RESIDENCE_PERMIT_BACK,
        DocsVerificationPhotosKeysEnum.ID_CARD_BACK,
        DocsVerificationPhotosKeysEnum.DRIVER_LICENSE_BACK,
    ],
} as const;
